/**
 * Error Page
 * Generic error page for routing errors
 */

import { useRouteError, useNavigate } from 'react-router-dom';
import { Button } from '@/components/common';

export default function ErrorPage() {
  const error = useRouteError() as { statusText?: string; message?: string };
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white px-4 py-8">
      <div className="max-w-2xl mx-auto space-y-6">
        {/* Page Header */}
        <div className="text-center mb-10">
          <h1 className="text-4xl font-script text-error-600 italic tracking-wide">
            Oops!
          </h1>
          <p className="text-sm text-neutral-500 mt-2">
            Something went wrong
          </p>
        </div>

        {/* Error Details */}
        <div className="bg-error-50 border border-error-200 rounded-2xl px-5 py-4">
          <div className="flex items-start gap-3">
            <svg
              className="h-5 w-5 text-error-500 flex-shrink-0 mt-0.5"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                clipRule="evenodd"
              />
            </svg>
            <p className="text-sm text-error-700">
              {error?.statusText || error?.message || 'An unexpected error occurred'}
            </p>
          </div>
        </div>

        {/* Help Information */}
        <div className="bg-neutral-50 rounded-2xl px-5 py-4 text-sm text-neutral-600 space-y-2">
          <p className="font-medium text-neutral-700">What you can do</p>
          <ul className="list-disc list-inside space-y-1 ml-1">
            <li>Try refreshing the page</li>
            <li>Go back to the login page and try again</li>
            <li>Contact support if the problem persists</li>
          </ul>
        </div>

        {/* Action Button */}
        <div className="pt-4">
          <Button
            variant="primary"
            onClick={() => navigate('/login')}
            className="!rounded-full !px-8 !py-2.5 !bg-primary-500 hover:!bg-primary-600 !text-white !text-sm !font-medium"
          >
            Go to Login
          </Button>
        </div>
      </div>
    </div>
  );
}
